
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { X, Plus, User } from 'lucide-react';
import { FoodItem } from './types';

interface SelectedFoodProps {
  selectedFood: FoodItem;
  amount: number;
  onAmountChange: (amount: number) => void;
  onAddFood: () => void;
  onClearSelection: () => void;
}

const SelectedFood: React.FC<SelectedFoodProps> = ({
  selectedFood,
  amount,
  onAmountChange,
  onAddFood,
  onClearSelection
}) => {
  // Calcular valores nutricionales según la cantidad
  const calculateNutrientValue = (baseValue: number, quantity: number) => {
    return Math.round((baseValue * quantity / 100) * 10) / 10;
  };

  const calculatedCalories = calculateNutrientValue(selectedFood.calories, amount);
  const calculatedProtein = calculateNutrientValue(selectedFood.protein, amount);
  const calculatedCarbs = calculateNutrientValue(selectedFood.carbs, amount);
  const calculatedFat = calculateNutrientValue(selectedFood.fat, amount);

  return (
    <Card className="mt-3 border border-green-200">
      <CardContent className="p-3">
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center gap-2">
            <h4 className="font-medium">{selectedFood.name}</h4>
            {selectedFood.source === 'Personalizado' && (
              <span className="inline-flex items-center gap-1 px-2 py-1 text-xs bg-purple-100 text-purple-700 rounded-full">
                <User size={12} />
                Personalizado
              </span>
            )}
          </div>
          <Button 
            variant="ghost" 
            size="sm" 
            className="h-8 w-8 p-0" 
            onClick={onClearSelection}
          >
            <X size={16} />
          </Button>
        </div>
        
        <div className="text-sm flex gap-3 text-gray-700 mb-3">
          <span>{calculatedCalories} kcal</span>
          <span>P: {calculatedProtein}g</span>
          <span>C: {calculatedCarbs}g</span>
          <span>G: {calculatedFat}g</span>
        </div>

        <div className="flex gap-2 items-center">
          <Input
            type="number"
            value={amount}
            onChange={(e) => onAmountChange(Number(e.target.value))}
            className="w-24"
            min="1"
          />
          <span className="text-sm">gramos</span>
          
          <Button 
            onClick={onAddFood}
            className="ml-auto"
            size="sm"
          >
            <Plus size={16} className="mr-1" />
            Añadir
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default SelectedFood;
